import { render, staticRenderFns } from "./addThreeLogin.vue?vue&type=template&id=9b582c1e&"
import script from "./addThreeLogin.vue?vue&type=script&lang=js&"
export * from "./addThreeLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b582c1e')) {
      api.createRecord('9b582c1e', component.options)
    } else {
      api.reload('9b582c1e', component.options)
    }
    module.hot.accept("./addThreeLogin.vue?vue&type=template&id=9b582c1e&", function () {
      api.rerender('9b582c1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/loginconfig/components/addThreeLogin.vue"
export default component.exports